import { privateTemplateTagAPI } from '../../../../entities/template/private-template-tag';

/**
 * Загружает теги приватных шаблонов из API.
 */
export const usePrivateTemplateTagsData = () => {
	const { data: tags } = privateTemplateTagAPI.useGetAllQuery({
		page: 1,
		limit: 127,
		search: '',
	});

	return { tags };
};
